import { render, staticRenderFns } from "./DetalleArticulo.vue?vue&type=template&id=7a85495c&scoped=true&"
import script from "./DetalleArticulo.vue?vue&type=script&lang=js&"
export * from "./DetalleArticulo.vue?vue&type=script&lang=js&"
import style0 from "./DetalleArticulo.vue?vue&type=style&index=0&id=7a85495c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a85495c",
  null
  
)

export default component.exports